var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOxp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 28,
    viewBox: "0 0 40 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "go7jwhckyc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.001%",
    y1: "49.998%",
    x2: "100.001%",
    y2: "49.998%",
    id: "zpgfqdzi1e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0301F7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2301EA",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5001D8",
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7300CA",
    offset: "52%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C00C0",
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C00BA",
    offset: "87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A100B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.133 0a3.046 3.046 0 0 0-.226.014c-.933 0-1.867.463-2.427 1.205A20.526 20.526 0 0 0 0 14.007c0 4.633 1.587 9.174 4.48 12.788.56.742 1.494 1.112 2.427 1.205h.187c.84 0 1.68-.37 2.427-1.205l7.56-7.506a4.757 4.757 0 0 1 6.721 0l7.56 7.506c.747.742 1.68 1.112 2.614 1.02.934 0 1.867-.464 2.427-1.205 2.894-3.521 4.48-8.062 4.48-12.696 0-4.54-1.586-9.081-4.48-12.695C35.843.477 34.91.107 33.976.014c-1.027 0-1.96.37-2.613 1.02l-7.561 7.505a4.757 4.757 0 0 1-6.72 0L9.52 1.033C8.864.382 8.063.016 7.245 0h-.112zm18.63 10.486 7.56-7.507c.187-.092.28-.092.373-.092.094 0 .187.092.28.185 2.52 3.15 3.92 6.95 3.92 10.935 0 3.985-1.4 7.877-3.92 10.935-.093.185-.186.185-.28.185-.093 0-.28 0-.373-.092l-7.56-7.507c-2.988-2.965-7.841-2.965-10.828 0l-7.561 7.507c-.187.092-.28.092-.373.092-.094 0-.187-.092-.28-.185-2.52-3.15-3.92-6.95-3.92-10.935 0-3.985 1.4-7.877 3.92-10.935.093-.185.28-.185.373-.185 0 0 .187 0 .28.092l7.56 7.507a7.66 7.66 0 0 0 5.414 2.224 7.66 7.66",
    id: "sga9nm5xya"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.133 0a3.046 3.046 0 0 0-.226.014c-.933 0-1.867.463-2.427 1.205A20.526 20.526 0 0 0 0 14.007c0 4.633 1.587 9.174 4.48 12.788.56.742 1.494 1.112 2.427 1.205h.187c.84 0 1.68-.37 2.427-1.205l7.56-7.506a4.757 4.757 0 0 1 6.721 0l7.56 7.506c.747.742 1.68 1.112 2.614 1.02.934 0 1.867-.464 2.427-1.205 2.894-3.521 4.48-8.062 4.48-12.696 0-4.54-1.586-9.081-4.48-12.695C35.843.477 34.91.107 33.976.014c-1.027 0-1.96.37-2.613 1.02l-7.561 7.505a4.757 4.757 0 0 1-6.72 0L9.52 1.033C8.864.382 8.063.016 7.245 0h-.112zm18.63 10.486 7.56-7.507c.187-.092.28-.092.373-.092.094 0 .187.092.28.185 2.52 3.15 3.92 6.95 3.92 10.935 0 3.985-1.4 7.877-3.92 10.935-.093.185-.186.185-.28.185-.093 0-.28 0-.373-.092l-7.56-7.507c-2.988-2.965-7.841-2.965-10.828 0l-7.561 7.507c-.187.092-.28.092-.373.092-.094 0-.187-.092-.28-.185-2.52-3.15-3.92-6.95-3.92-10.935 0-3.985 1.4-7.877 3.92-10.935.093-.185.28-.185.373-.185 0 0 .187 0 .28.092l7.56 7.507a7.66 7.66 0 0 0 5.414 2.224 7.66 7.66 0 0 0 5.414-2.224z",
    id: "o03g07tz3d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "gm8r49hmdb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sga9nm5xya"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#gm8r49hmdb)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#go7jwhckyc)",
    xlinkHref: "#o03g07tz3d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#zpgfqdzi1e)",
    xlinkHref: "#o03g07tz3d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxp);
export default __webpack_public_path__ + "static/media/oxp.9ea3f4e5e412f86f43af0788cbf81742.svg";
export { ForwardRef as ReactComponent };